import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Box,
  Typography,
  LinearProgress,
} from "@mui/material";

const PaymentForm = ({ onSubmit, widgetReady }) => {
  const [formData, setFormData] = useState({
    amount: "",
    email: "",
    firstName: "",
    lastName: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Amount (USD)"
            name="amount"
            type="number"
            value={formData.amount}
            onChange={handleChange}
            inputProps={{ min: "0.01", step: "0.01" }}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="First Name"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Last Name"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Description (Optional)"
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </Grid>
      </Grid>

      {!widgetReady && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Loading payment gateway...
          </Typography>
          <LinearProgress sx={{ mt: 1 }} />
        </Box>
      )}
      <Button
        type="submit"
        variant="contained"
        fullWidth
        size="large"
        sx={{ mt: 3 }}
        disabled={!widgetReady}
      >
        Proceed to Payment
      </Button>
    </Box>
  );
};

export default PaymentForm;
